var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelPrint14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M3.816 4.403c0-.307.285-.612.637-.683l5.495-1.114c.346-.07.637.12.637.425v5.014c0 .307-.285.612-.637.683l-.92.186.001 1.9c0 .28-.244.447-.548.374l-4.117-.99c-.302-.073-.548-.358-.548-.639ZM7.872 7.14l-2.494.458a.35.35 0 1 0 .126.688L8 7.83a.35.35 0 0 0-.127-.688M9.05 5.449l-3.694.679a.35.35 0 0 0 .126.688l3.694-.678a.35.35 0 1 0-.126-.689m-.017-1.44-3.695.679a.35.35 0 1 0 .127.688l3.694-.679a.35.35 0 0 0-.126-.688"
}))));
export default SvgChannelPrint14;